module.exports = __webpack_public_path__ + "redfin_logo.787885f.jpg";